<div class="page-info-2 {{styling}} no-print" [class.minimum]="styling === 'minimum'" [class.has-actions]="actions" [class.has-clicked]="hasClicked" [class.view-detail]="detail" [class.view-overview]="!detail">
  <div class="overview">
    <div class="title">{{title}}</div>
    @if (actions) {
      <div class="actions">
        @for (action of actions; track action) {
          <button class="btn btn-sm btn-secondary" [routerLink]="action.link">
            <i class="fa fa-{{action.icon}}"></i> {{action.title}}</button>
          }
        </div>
        <div></div>
      }
      <p class="body">{{subtitle}}</p>
    </div>
    <div class="detail">
      <p class="title">{{title}}</p>
      <p class="body" (click)="back()">
        <i class="fa fa-chevron-left"></i>&nbsp; {{detail}}</p>
      </div>
    </div>